module.exports = __webpack_public_path__ + "static/media/emailverified.d2a0d877.svg";